import { useState, useEffect } from 'react'
import TrashCanIcon from '../../asset/TrashCanIcon'
import { IEconomicAnalysis, rows } from '../../store/EconomicAnalysis'

type TableProps<T, U, V> = {
  customers: T[]
  plans: U[]
  recoilValue: V[]
  setRecoilValue: React.Dispatch<React.SetStateAction<V[]>>
  deleteCustomerRow: (id: string) => void
  rows: rows<T, U> | rows<T, U>[]
}

export const UnifiedTable = <T, U, V extends IEconomicAnalysis>(
  props: TableProps<T, U, V>
) => {
  const {
    customers,
    deleteCustomerRow,
    plans,
    recoilValue,
    setRecoilValue,
    rows,
  } = props
  const [customersList, setCustomersList] = useState<T[]>([])
  const [planList, setPlanList] = useState<U[]>([])
  const row = rows
  const idList = recoilValue
  const setidList = setRecoilValue

  useEffect(() => {
    setCustomersList(customers)
    setPlanList(plans)
  }, [customers, plans])

  const handleGetCustomer = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ): void => {
    e.preventDefault()
    let selected = e.target.value

    setidList(
      idList.map((m: V) => {
        if (m.index === String(index)) {
          const currentPlanId = m.plan?._id
          const currentPlanCustId = (
            planList as { _id: string; custId?: string }[]
          ).find((plan) => plan._id === currentPlanId)?.custId
          const shouldClearPlan =
            selected !== 'default' &&
            currentPlanId &&
            currentPlanCustId !== selected

          return {
            ...m,
            customer: {
              _id: selected === 'default' ? undefined : selected,
            },
            plan: shouldClearPlan
              ? {
                  _id: undefined,
                }
              : m.plan,
          }
        }
        return m
      })
    )
  }

  const handleGetPlans = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ): void => {
    e.preventDefault()
    let selected = e.target.value
    const selectedPlan = (planList as { _id: string; custId?: string }[]).find(
      (plan) => plan._id === selected
    )

    setidList(
      idList.map((m) => {
        if (m.index === String(index)) {
          return {
            ...m,
            customer: {
              _id: selectedPlan?.custId,
            },
            plan: {
              _id: selected === 'default' ? undefined : selected,
            },
          }
        }
        return m
      })
    )
  }

  return (
    <table>
      <thead>
        <tr>
          <th></th>
          <th>고객명</th>
          <th>요금제</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(row) &&
          row.map((row, index) => (
            <tr key={row.id}>
              <td onClick={() => row.index && deleteCustomerRow(row.index)}>
                <TrashCanIcon />
              </td>
              <td>
                <select
                  value={idList[index]?.customer?._id || 'default'}
                  onChange={(e) => handleGetCustomer(e, index)}
                >
                  <option value="default">선택해주세요</option>
                  {Array.isArray(customersList) ? (
                    (customersList as { _id: string; name: string }[]).map(
                      (m) => (
                        <option key={m._id} value={m._id}>
                          {m.name}
                        </option>
                      )
                    )
                  ) : (
                    <option>등록해주세요</option>
                  )}
                </select>
              </td>
              <td>
                <select
                  value={idList[index]?.plan?._id || 'default'}
                  onChange={(e) => handleGetPlans(e, index)}
                >
                  <option value="default">선택해주세요</option>
                  {Array.isArray(planList) ? (
                    (
                      planList as {
                        _id: string
                        name: string
                        custId?: string
                      }[]
                    )
                      .filter(
                        (m) =>
                          !idList[index]?.customer?._id ||
                          m.custId === idList[index]?.customer?._id
                      )
                      .map((m) => (
                        <option key={m._id} value={m._id}>
                          {m.name}
                        </option>
                      ))
                  ) : (
                    <option>등록해주세요.</option>
                  )}
                </select>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}
